import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "ADD_FUNDS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setStripeAddressDetails: (state, action) => {
            state.stripeAddressDetails = action.payload;
        },
        setIsStripeAddressFormValid: (state, action) => {
            state.isStripeAddressFormValid = action.payload;
        },
        setStripeSavedCardsList: (state, action) => {
            state.stripeSavedCardsList = action.payload;
        },
        setSelectedCard: (state, action) => {
            state.selectedCard = action.payload;
        },
        setSelectedPaymentMode: (state, action) => {
            state.selectedPaymentMode = action.payload;
        },
        setEnteredAmount: (state, action) => {
            state.enteredAmount = action.payload;
        },
        setSalesTax: (state, action) => {
            state.salesTax = action.payload;
        },
        setStripeSalexTaxCalculationSuccessfull: (state, action) => {
            state.stripeSalexTaxCalculationSuccessfull = action.payload;
        },
        setAddCardDetails: (state, action) => {
            state.addCardDetails = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setZipCodeValidationSuccess: (state, action) => {
            state.zipCodeValidationSuccess = action.payload;
        },
        setOpenPrepayFundAccessConfirmationModal: (state, action) =>{
            state.openPrepayFundAccessConfirmationModal = action.payload
        },
        setPaymentMethodDetails: (state, action) => {
            state.paymentMethodDetails = action.payload
        },
        setStripeCardDetails: (state, action) => {
            state.stripeCardDetails = action.payload;
        }
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.LOADING },
        stripeAddressDetails: {},
        isStripeAddressFormValid: false,
        stripeSavedCardsList: [],
        stripeCardDetails: {},
        selectedCard: {},
        selectedPaymentMode: {},
        enteredAmount: "",
        salesTax: 0,
        stripeSalexTaxCalculationSuccessfull: false,
        addCardDetails: false,
        zipCodeValidationSuccess: false,
        openPrepayFundAccessConfirmationModal: false,
        paymentMethodDetails: {},
    },
});

export const { setStripeAddressDetails, setStripeCardDetails,setSalesTax, setIsStripeAddressFormValid, setStripeSavedCardsList, setSelectedCard, setSelectedPaymentMode, setEnteredAmount, setStripeSalesTax, setStripeSalexTaxCalculationSuccessfull, setAddCardDetails, setLoadingState, setZipCodeValidationSuccess, setOpenPrepayFundAccessConfirmationModal, setPaymentMethodDetails } = actions;
